<template>
  <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" :width="dialogWidth" center custom-class="contact-dialog"
    destroy-on-close :close-on-click-modal="false">
    <div class="dialog-wrapper">
      <el-form :model="formData" label-width="140px" label-position="left" class="dialog-form">
        <el-form-item label="*姓名" style="width: 100%">
          <el-input v-model="formData.name" autocomplete="off" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="*性别">
          <el-radio-group v-model="formData.sex">
            <el-radio-button class="radio-button-one" label="1" size="medium">男</el-radio-button>
            <el-radio-button label="0" size="medium">女</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="电话">
          <el-input v-model="formData.phoneNo" autocomplete="off" placeholder="请输入手机号码"></el-input>
        </el-form-item>
        <el-form-item label="*出生日期">
          <el-input v-model="formData.displayBirth" autocomplete="off" placeholder="请选择出生日期"
            @focus="birthdayDialogShow = true"></el-input>
        </el-form-item>
        <el-form-item label="*出生时">
          <el-select v-model="formData.birthHour" :disabled="birthHourUnknown" placeholder="请选择" style="width: 120px">
            <el-option v-for="h in hourOptions" :key="h.value" :label="h.label" :value="h.value"></el-option>
          </el-select>
          <el-checkbox v-model="birthHourUnknown" style="margin-left: 15px"
            @change="onBirthHourUnknownChange">不知道</el-checkbox>
        </el-form-item>
        <el-form-item label="*出生分">
          <el-select v-model="formData.birthMinute" :disabled="birthMinuteUnknown || birthHourUnknown" placeholder="请选择"
            style="width: 120px">
            <el-option v-for="m in minuteOptions" :key="m.value" :label="m.label" :value="m.value"></el-option>
          </el-select>
          <el-checkbox v-model="birthMinuteUnknown" :disabled="birthHourUnknown" style="margin-left: 15px"
            @change="onBirthMinuteUnknownChange">不知道</el-checkbox>
        </el-form-item>
        <span style="color: #dd3131; font-size: 16px; margin-left: 100px">在本系统其他页面，只展示阳历（公历）生日。</span>
        <el-form-item label="*常住地址">
          <el-cascader class="address-picker" :filterable="true" placeholder="选择或根据省市区搜索常住地址" v-model="formData.liveArea"
            :options="options"></el-cascader>
        </el-form-item>
        <el-form-item label="*出生地址">
          <el-cascader class="address-picker address-picker2" :filterable="true" placeholder="选择或根据省市区搜索出生地址"
            v-model="formData.birthArea" :options="options"></el-cascader>
          <el-button v-show="copyVisible" style="margin-left: 20px" type="success" plain @click="copyAddress" size="small"
            round>和常住地一致</el-button>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="btn-dialog-cancel" @click="dialogVisible = false">取 消</el-button>
        <el-button class="btn-dialog-confirm" :loading="dialogBtnLoading" type="primary" @click="handleSubmit">{{
          confirmText }}</el-button>
      </span>
      <span v-if="showTips" style="
          width: 100%;
          padding-left: 100px;
          margin-top: 30px;
          font-size: 18px;
          color: #666;
        ">温馨提示：<br />
        1、加*为必填项。<br />
        2、请务必核实阳历、阴历生日。<br />
        3、请确认各项信息准确。<br />
        4、在本系统中其他页面，只展示阳历（公历）生日，请您注意。</span>
    </div>
    <birthday-picker :visible.sync="birthdayDialogShow" :birthday="formData.birthday"
      @confirm="onBirthdayConfirm"></birthday-picker>
  </el-dialog>
</template>

<script>
import area from "../../js/area";
import BirthdayPicker from "./BirthdayPicker.vue";

export default {
  components: {
    BirthdayPicker: BirthdayPicker,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    mode: {
      type: String,
      default: "add",
    },
    patientData: {
      type: Object,
      default: function () {
        return null;
      },
    },
    addressRequired: {
      type: Boolean,
      default: true,
    },
    dialogWidth: {
      type: String,
      default: "600px",
    },
    showTips: {
      type: Boolean,
      default: false,
    },
    addTitle: {
      type: String,
      default: "",
    },
  },
  data: function () {
    return {
      formData: {
        name: "",
        sex: "1",
        phoneNo: "",
        birthday: "",
        displayBirth: "",
        lunarBirthday: "",
        birthArea: [],
        liveArea: [],
        birthHour: "12",
        birthMinute: "30",
      },
      hourOptions: [],
      minuteOptions: [],
      birthHourUnknown: false,
      birthMinuteUnknown: false,
      options: [],
      copyVisible: false,
      dialogBtnLoading: false,
      birthdayDialogShow: false,
    };
  },
  created: function () {
    var hours = [];
    for (var i = 0; i < 24; i++) {
      var hourStr = i < 10 ? "0" + i : "" + i;
      hours.push({ label: hourStr + "时", value: hourStr });
    }
    this.hourOptions = hours;
    var minutes = [];
    for (var j = 0; j < 60; j++) {
      var minuteStr = j < 10 ? "0" + j : "" + j;
      minutes.push({ label: minuteStr + "分", value: minuteStr });
    }
    this.minuteOptions = minutes;
  },
  computed: {
    dialogVisible: {
      get: function () {
        return this.visible;
      },
      set: function (val) {
        this.$emit("update:visible", val);
      },
    },
    dialogTitle: function () {
      if (this.mode === "edit") return "编辑患者信息";
      return this.addTitle && this.addTitle.length > 0 ? this.addTitle : "添加患者信息";
    },
    confirmText: function () {
      return this.mode === "edit" ? "确 认" : "添 加";
    },
  },
  watch: {
    visible: function (val) {
      if (val) {
        this.initForm();
        this.generateAreaNodes();
      }
    },
    "formData.liveArea": {
      handler: function (newValue) {
        if (newValue && newValue.length > 0) {
          this.copyVisible = true;
        }
      },
      deep: true,
    },
  },
  methods: {
    initForm: function () {
      if (this.mode === "edit" && this.patientData) {
        this.formData = Object.assign({}, this.patientData);
        this.formData.liveArea = this.textToAreaCodes(this.formData.liveArea);
        this.formData.birthArea = this.textToAreaCodes(this.formData.birthArea);
        if (!this.formData.birthHour && this.formData.birthHour !== 0) {
          this.formData.birthHour = "12";
        }
        if (!this.formData.birthMinute && this.formData.birthMinute !== 0) {
          this.formData.birthMinute = "30";
        }
        this.birthHourUnknown =
          this.formData.birthHour === "-1" || this.formData.birthHour === "--";
        this.birthMinuteUnknown =
          this.formData.birthMinute === "-1" ||
          this.formData.birthMinute === "--";
      } else {
        this.formData = {
          name: "",
          sex: "1",
          phoneNo: "",
          birthday: "",
          displayBirth: "",
          lunarBirthday: "",
          birthArea: [],
          liveArea: [],
          birthHour: "12",
          birthMinute: "30",
        };
        this.birthHourUnknown = false;
        this.birthMinuteUnknown = false;
      }
      this.copyVisible = false;
      this.dialogBtnLoading = false;
    },
    textToAreaCodes: function (text) {
      if (!text || typeof text !== "string" || text.length === 0) {
        return [];
      }
      var provinceCode = "";
      var provinceName = "";
      for (var pCode in area.province_list) {
        var pName = area.province_list[pCode];
        if (text.indexOf(pName) === 0) {
          if (pName.length > provinceName.length) {
            provinceCode = pCode;
            provinceName = pName;
          }
        }
      }
      if (!provinceCode) {
        return [];
      }
      var cityCode = "";
      var cityName = "";
      var provincePrefix = provinceCode.substring(0, 2);
      var remainingText = text.substring(provinceName.length);
      for (var cCode in area.city_list) {
        if (cCode.substring(0, 2) !== provincePrefix) continue;
        var cName = area.city_list[cCode];
        if (
          remainingText.indexOf(cName) === 0 &&
          cName.length > cityName.length
        ) {
          cityCode = cCode;
          cityName = cName;
        }
      }
      if (!cityCode) {
        return [provinceCode];
      }
      var countyCode = "";
      var countyName = "";
      var cityPrefix = cityCode.substring(0, 4);
      remainingText = remainingText.substring(cityName.length);
      for (var coCode in area.county_list) {
        if (coCode.substring(0, 4) !== cityPrefix) continue;
        var coName = area.county_list[coCode];
        if (
          remainingText.indexOf(coName) === 0 &&
          coName.length > countyName.length
        ) {
          countyCode = coCode;
          countyName = coName;
        }
      }
      if (!countyCode) {
        return [provinceCode, cityCode];
      }
      return [provinceCode, cityCode, countyCode];
    },
    generateAreaNodes: function () {
      var nodes = [];
      for (var key in area.province_list) {
        var item = {
          label: area.province_list[key],
          value: key,
          children: [],
        };
        var provinceCode = key.substring(0, 2);
        for (var cityKey in area.city_list) {
          if (provinceCode == cityKey.substring(0, 2)) {
            var cityItem = {
              label: area.city_list[cityKey],
              value: cityKey,
              children: [],
            };
            var cityCode = cityKey.substring(0, 4);
            for (var countyKey in area.county_list) {
              if (cityCode == countyKey.substring(0, 4)) {
                var countyItem = {
                  label: area.county_list[countyKey],
                  value: countyKey,
                };
                cityItem.children.push(countyItem);
              }
            }
            item.children.push(cityItem);
          }
        }
        nodes.push(item);
      }
      this.options = nodes;
    },
    copyAddress: function () {
      this.formData.birthArea = this.formData.liveArea.slice();
    },
    onBirthHourUnknownChange: function (val) {
      if (val) {
        this.formData.birthHour = "--";
        this.formData.birthMinute = "--";
        this.birthMinuteUnknown = true;
      } else {
        this.formData.birthHour = "";
        this.formData.birthMinute = "";
        this.birthMinuteUnknown = false;
      }
    },
    onBirthMinuteUnknownChange: function (val) {
      if (val) {
        this.formData.birthMinute = "--";
      } else {
        this.formData.birthMinute = "";
      }
    },
    onBirthdayConfirm: function (result) {
      this.formData.birthday = result.birthday;
      this.formData.displayBirth = result.displayBirth;
      this.formData.lunarBirthday = result.lunarBirthday;
    },
    handleSubmit: function () {
      if (!this.formData.name || this.formData.name.length == 0) {
        this.$message({ message: "请输入姓名", type: "warning" });
        return;
      }
      if (!this.formData.birthday || this.formData.birthday.length == 0) {
        this.$message({ message: "请选择出生日期", type: "warning" });
        return;
      }
      var minDate = new Date("1900-01-01");
      var currentDate = new Date(this.formData.birthday);
      if (currentDate < minDate) {
        this.$message({
          message: "出生日期不能小于1900-01-01",
          type: "warning",
        });
        return;
      }
      if (this.formData.birthHour === "" || this.formData.birthHour == null) {
        this.$message({ message: "请选择出生时", type: "warning" });
        return;
      }
      if (this.formData.birthMinute === "" || this.formData.birthMinute == null) {
        this.$message({ message: "请选择出生分", type: "warning" });
        return;
      }
      if (this.addressRequired) {
        if (!this.formData.liveArea || this.formData.liveArea.length == 0) {
          this.$message({ message: "请选择常住地址", type: "warning" });
          return;
        }
        if (!this.formData.birthArea || this.formData.birthArea.length == 0) {
          this.$message({ message: "请选择出生地址", type: "warning" });
          return;
        }
      }
      var submitData = JSON.parse(JSON.stringify(this.formData));
      var liveArea = submitData.liveArea;
      var birthArea = submitData.birthArea;
      if (Array.isArray(submitData.liveArea)) {
        submitData.liveArea = liveArea
          .map(function (key, index) {
            if (index == 0) {
              return area.province_list[key];
            } else if (index == 1) {
              return area.city_list[key];
            } else {
              return area.county_list[key];
            }
          })
          .join("");
      }
      if (Array.isArray(submitData.birthArea)) {
        submitData.birthArea = birthArea
          .map(function (key, index) {
            if (index == 0) {
              return area.province_list[key];
            } else if (index == 1) {
              return area.city_list[key];
            } else {
              return area.county_list[key];
            }
          })
          .join("");
      }
      this.dialogBtnLoading = true;
      this.wjtHttp.post(
        this,
        "/api/patient/v1",
        submitData,
        false,
        function (response) {
          this.dialogBtnLoading = false;
          if (response.data.code == 200) {
            if (this.mode === "edit") {
              this.$message({ message: "操作成功", type: "success" });
              this.dialogVisible = false;
              this.$emit("success", submitData);
            } else {
              this.wjtHttp.post(
                this,
                "/api/patient/v1/list",
                { name: this.formData.name.trim() },
                false,
                function (res) {
                  var data = res.data;
                  if (data.code == 200) {
                    var searchResult = data.rows;
                    if (!this.utils.isEmptyStr(searchResult)) {
                      this.$message({ message: "添加成功", type: "success" });
                      this.dialogVisible = false;
                      if (searchResult.length > 1) {
                        this.$emit("success-multi", searchResult);
                      } else {
                        this.$emit("success", searchResult[0]);
                      }
                    } else {
                      this.$message({
                        message: "添加失败，请联系管理员",
                        type: "warning",
                      });
                    }
                  } else {
                    this.$message({
                      message:
                        data.msg && data.msg.length > 0
                          ? data.msg
                          : "添加异常，请联系管理员",
                      type: "error",
                    });
                  }
                }.bind(this),
                function (err) {
                  console.log(err);
                  this.dialogBtnLoading = false;
                }.bind(this)
              );
            }
          } else {
            this.$message({
              message:
                response.data.msg && response.data.msg.length > 0
                  ? response.data.msg
                  : "操作失败，请联系管理员",
              type: "error",
            });
          }
        }.bind(this),
        function (err) {
          console.log(err);
          this.dialogBtnLoading = false;
          this.$message({
            message: "操作失败，请联系管理员",
            type: "error",
          });
        }.bind(this)
      );
    },
  },
};
</script>

<style scoped>
.dialog-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.dialog-form {
  width: 550px;
}

.radio-button-one {
  margin-right: 16px;
}

.address-picker {
  width: 100%;
}

:deep(.el-radio-button__inner) {
  min-width: 80px;
  width: 80px !important;
  height: 40px !important;
  line-height: 38px !important;
  padding: 0 12px !important;
  border-radius: 20px !important;
  border: 1px solid #20863F;
  background-color: #fff;
  color: #20863F;
  font-size: 16px !important;
  font-weight: 600;
  transition: all 0.25s ease;
  box-shadow: none !important;
  box-sizing: border-box;
  display: inline-block;
  text-align: center;
  white-space: nowrap;
}
:deep(.el-radio-button.is-active .el-radio-button__inner) {
  background-color: #20863F;
  border-color: #20863F;
  color: #fff;
  box-shadow: 0 4px 12px rgba(44, 132, 82, 0.25) !important;
}
:deep(.el-radio-button__inner:hover) {
  color: #20863F;
  background-color: #f3fbf6;
}
:deep(.el-radio-button.is-active .el-radio-button__inner:hover) {
  color: #fff;
  background-color: #257648;
  border-color: #257648;
}

:deep(.el-input__inner:focus),
:deep(.el-textarea__inner:focus),
:deep(.el-select .el-input.is-focus .el-input__inner),
:deep(.el-cascader .el-input.is-focus .el-input__inner) {
  border-color: #20863F;
}

.contact-dialog {
  border-radius: 10px;
}

.btn-dialog-cancel {
  margin-right: 50px;
  width: 150px;
  border-radius: 30px;
  margin-top: 30px;
  border-color: #20863F;
  color: #20863F;
}

.btn-dialog-cancel:hover {
  background-color: #f3fbf6;
  border-color: #20863F;
  color: #20863F;
}

.btn-dialog-confirm {
  margin-left: 50px;
  width: 150px;
  border-radius: 30px;
  margin-top: 30px;
  background-color: #20863F;
  border-color: #20863F;
  color: #fff;
}

.btn-dialog-confirm:hover {
  background-color: #257648;
  border-color: #257648;
  color: #fff;
}
</style>
